
var BannerCarousel;


jQuery(document).ready(function ($) {

    
    /**
     * 
     * Add controler for swipers slider
     * 
     */
    //https://developers.elementor.com/expose-swiper-in-elementor/
    //https://github.com/elementor/elementor/issues/11067#issuecomment-613521991
    
    $(window).on('elementor/frontend/init', function () {

        $('body').append('<div class="sr-only" id="sr-msg" role="alert" aria-live="polite" aria-atomic="true"></div>');

        // wait for elementor pro to load
        elementorFrontend.on('components:init', function () {
  
            setTimeout(function(){
                $('.elementor-swiper-button').removeAttr("aria-label");
                BannerCarouselFunc();
                TestiCarouselFunc();
            } ,500);

            
        });


        function BannerCarouselFunc(){
                 
            //pause play button for #images-slider                
          
            BannerCarousel = jQuery( '#main-banner .swiper-container' );
            var swiperInstance = BannerCarousel.data( 'swiper' );

            if( swiperInstance == undefined ){
                //console.log("tswiperInstance == undefined")
                return;
            }
            
            updateAriaHidden(swiperInstance);
            swiperInstance.on('slideChangeTransitionEnd',function() {

                updateAriaHidden(swiperInstance);
            });
                               

            $('#main-banner ').prepend(  PPButtonElemntFunc("main-play-pause") );
            
           setTimeout( function(){

                if( swiperInstance != undefined){
                    if (  swiperInstance.autoplay.running  ){
                

                        $('#main-play-pause .play').hide();
                        $('#main-play-pause .pause').show();
    
                    }else{
                        $('#main-play-pause .play').show();
                        $('#main-play-pause .pause').hide();
                    }   
                }

             },0 );
                

            if( swiperInstance != undefined){
                $("#main-play-pause").click(function(){

                    if ( swiperInstance.autoplay.running  ){

                        swiperInstance.autoplay.stop();
                        $('#main-play-pause .play').show();
                        $('#main-play-pause .pause').hide();

                    }else{
                        swiperInstance.slideNext();
                        swiperInstance.autoplay.start();
                        $('#main-play-pause .play').hide();
                        $('#main-play-pause .pause').show();
                    }
                });
               
                // making a event to next and previus button so the content will be send to aria-live div
                $('#main-banner .elementor-swiper-button').on('click', function(event){

                    var msg = $("#main-banner .swiper-slide-active .elementor-slide-description").text();                     

                    $("#sr-msg").text(msg);
                  
                })
            }
        }

        function TestiCarouselFunc(){
                 
            //pause play button for #images-slider                
          
            TestiCarousel = jQuery( '#testimonies-slider .swiper-container' );
            var testswiperInstance = TestiCarousel.data( 'swiper' );

            if( testswiperInstance == undefined ){
                //console.log('testswiperInstance == undefined');
                return;
            }
            
            updateAriaHidden(testswiperInstance);
            testswiperInstance.on('slideChangeTransitionEnd',function() {

                updateTestiAriaHidden(testswiperInstance);
            });
                               

            $('#testimonies-slider').append(  PPButtonElemntFunc("testi-play-pause") );
            
           setTimeout( function(){

                if( testswiperInstance != undefined){
                    if (  testswiperInstance.autoplay.running  ){
                

                        $('#testi-play-pause .play').hide();
                        $('#testi-play-pause .pause').show();
    
                    }else{
                        $('#testi-play-pause .play').show();
                        $('#testi-play-pause .pause').hide();
                    }   
                }

             },0 );
                

            if( testswiperInstance != undefined){
                $("#testi-play-pause").click(function(){

                    if ( testswiperInstance.autoplay.running  ){

                        testswiperInstance.autoplay.stop();
                        $('#testi-play-pause .play').show();
                        $('#testi-play-pause .pause').hide();

                    }else{
                        testswiperInstance.slideNext();
                        testswiperInstance.autoplay.start();
                        $('#testi-play-pause .play').hide();
                        $('#testi-play-pause .pause').show();
                    }
                });
               
                // making a event to next and previus button so the content will be send to aria-live div
                $('#testimonies-slider .elementor-swiper-button').on('click', function(event){

                    var msg = $("#testimonies-slider .swiper-slide-active .elementor-testimonial__text").text();                     

                    $("#sr-msg").text(msg);
                  
                })
            }
        }
    });

    
       
}); // end of load


function updateAriaHidden(swiper) {
    // Get the active slide index and the total number of slides
    var activeIndex = swiper.activeIndex;
    /*var totalSlides = swiper.slides.length;*/
    
   

    jQuery("#main-banner .swiper-slide:not(.swiper-slide-active)").attr('aria-hidden', 'true');
    jQuery("#main-banner .swiper-slide:not(.swiper-slide-active) a.swiper-slide-inner").attr('tabindex', '-1')
    jQuery("#main-banner .swiper-slide.swiper-slide-active").attr('aria-hidden', 'false');
    jQuery("#main-banner .swiper-slide.swiper-slide-active a.swiper-slide-inner").attr('tabindex', '0')

}

function updateTestiAriaHidden(swiper) {
    // Get the active slide index and the total number of slides
  
    //console.log("updateTestiAriaHidden was called " );

    jQuery("#testimonies-slider .swiper-slide:not(.swiper-slide-active)").attr('aria-hidden', 'true');
   // jQuery('#testimonies-slider .swiper-slide:not(.swiper-slide-active) a.swiper-slide-inner").attr('tabindex', '-1')
    jQuery("#testimonies-slider .swiper-slide.swiper-slide-active").attr('aria-hidden', 'false');
   // jQuery("#main-banner .swiper-slide.swiper-slide-active a.swiper-slide-inner").attr('tabindex', '0')

}

function PPButtonElemntFunc(id){

    //console.log("PPButtonElemntFunc was called with "+id);

    var  buttonText = '<div class="pause-play-wrap"><button id="'+id+'" class="button">';
    buttonText =  buttonText+'<div class="play pause-play elementor-icon" ><span class="sr-only">הפעל התחלפות אוטומטית </span><svg aria-hidden="true" class="" viewBox="0 0 512 512"><path d="M371.7 238l-176-107c-15.8-8.8-35.7 2.5-35.7 21v208c0 18.4 19.8 29.8 35.7 21l176-101c16.4-9.1 16.4-32.8 0-42zM504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256z"></path></svg></div>';
    buttonText =  buttonText+'<div class="pause pause-play elementor-icon" ><span class="sr-only"> עצוד התחלפות אוטומטית</span><svg aria-hidden="true" class=""  viewBox="0 0 512 512"><path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm96-280v160c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16zm-112 0v160c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16z"></path></use></svg></div></button></div>';

    return buttonText;

    /*
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80V432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z"/></svg>
    */
}

